import React from 'react';
import MarkdownArtifactCard from '../components/MarkdownArtifactCard';
import EmbeddedArtifact from '../components/EmbeddedArtifact';
import {
  MarkdownArtifactProviderRoot,
  type MarkdownArtifactContextValue,
  type RenderArtifactCard,
  type RenderEmbeddedArtifact,
} from '@erikdakoda/markdown-ui/shared/MarkdownArtifactContext';

type MarkdownArtifactRendererProviderProps = {
  children: React.ReactNode;
  value?: MarkdownArtifactContextValue;
};

/**
 * Supplies markdown-ui with registry-backed artifact renderers via context.
 */
export default function MarkdownArtifactRendererProvider({
  children,
  value = {},
}: MarkdownArtifactRendererProviderProps) {
  'use memo';

  const renderEmbeddedArtifact: RenderEmbeddedArtifact = (props) => <EmbeddedArtifact {...props} />;

  const renderArtifactCard: RenderArtifactCard = (props) => <MarkdownArtifactCard {...props} />;

  return (
    <MarkdownArtifactProviderRoot
      className="markdown-artifact-renderer-provider"
      value={{
        ...value,
        renderEmbeddedArtifact,
        renderArtifactCard,
      }}
    >
      {children}
    </MarkdownArtifactProviderRoot>
  );
}
